import { FileText, type LucideIcon } from 'lucide-react';

import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';
import type { IllustrationKey } from '@/config/illustrations';
import { cn } from '@/lib/utils';

import { Illustration } from './Illustration';

interface EmptyStateProps {
  title: string;
  description?: React.ReactNode;
  icon?: LucideIcon;
  /** 상태 일러스트 키 — 지정 시 아이콘 대신 일러스트를 보인다(`config/illustrations.ts`). */
  illustration?: IllustrationKey;
  action?: React.ReactNode;
  /** 카드 안 작은 자리(패딩 축소). */
  compact?: boolean;
  className?: string;
}

/** 빈 상태 — Admin Kit Empty 구성(일러스트 또는 아이콘·제목·설명·액션). */
export function EmptyState({
  title,
  description,
  icon: Icon = FileText,
  illustration,
  action,
  compact,
  className,
}: EmptyStateProps) {
  return (
    <Empty className={cn(compact ? 'gap-4 p-6 md:p-8' : 'p-6 md:p-12', className)}>
      <EmptyHeader>
        {illustration ? (
          <EmptyMedia>
            <Illustration name={illustration} className={compact ? 'size-24' : undefined} />
          </EmptyMedia>
        ) : (
          <EmptyMedia variant="icon">
            <Icon aria-hidden="true" />
          </EmptyMedia>
        )}
        <EmptyTitle className={compact ? 'text-base' : undefined}>{title}</EmptyTitle>
        {description && <EmptyDescription>{description}</EmptyDescription>}
      </EmptyHeader>
      {action && <EmptyContent>{action}</EmptyContent>}
    </Empty>
  );
}
